import type {EditionApiModel} from '../../../api/program/edition';
import type {Nullable} from '../../utility-types';

import {isDefined} from '../../typecheck';

type TargetProgram = Nullable<{
  editions?: null | Nullable<EditionApiModel>[];
}>;

export const getLastEdition = (
  program: TargetProgram,
): EditionApiModel | null => {
  if (!isDefined(program)) {
    return null;
  }

  return program.editions?.slice().pop() ?? null;
};
